import { render, staticRenderFns } from "./duplicate-button.vue?vue&type=template&id=2c3f7ff2&scoped=true"
import script from "./duplicate-button.vue?vue&type=script&lang=js"
export * from "./duplicate-button.vue?vue&type=script&lang=js"
import style0 from "./duplicate-button.vue?vue&type=style&index=0&id=2c3f7ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f7ff2",
  null
  
)

export default component.exports